import { AppNS } from 'app';
import { assetUrl } from 'app/helpers/assetUrl';
import FileTypePdfIcon from 'app/ui/icons/FileTypePdfIcon';
import InspectorsIcon from 'app/ui/icons/InspectorsIcon';
import ProfileIcon from 'app/ui/icons/ProfileIcon';
import WindowBookmarkIcon from 'app/ui/icons/WindowBookmarkIcon';
import CertificatesMenuIcon from 'app/ui_v2/icons/CertificatesMenuIcon';
import InspectionsMenuIcon from 'app/ui_v2/icons/InspectionsMenuIcon';

export const getBackofficeNavigation = (): AppNS.NavigationElement[] => [
  {
    id: 'inspections',
    name: 'Inspections',
    url: '/dcra-inspections/inspections',
    path: ['/dcra-inspections'],
    icon: <InspectionsMenuIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'inspectors',
    name: 'Inspectors',
    url: '/backoffice/inspectors',
    path: '/backoffice/inspectors',
    icon: <InspectorsIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'profile',
    name: 'Profile',
    url: '/backoffice/account',
    path: '/backoffice/account',
    icon: <ProfileIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'guide',
    name: `User Guide`,
    url: assetUrl(
      '../../../DOB_Construction_Inspections_User_Guide_for_Admins_and_Inspectors.pdf'
    ),
    path: '/guide',
    icon: <FileTypePdfIcon />,
    disabled: false,
    show: true,
    isExternal: true,
  },
];

export const getElevatorsBackOfficeNavigation =
  (): AppNS.NavigationElement[] => [
    {
      id: 'elevatorsProjects',
      name: 'Projects',
      url: '/admin/elevators/projects',
      path: '/elevators/projects',
      icon: <WindowBookmarkIcon />,
      disabled: false,
      show: true,
      main: true,
    },
    {
      id: 'elevatorsInspections',
      name: 'Inspections',
      url: '/admin/elevators/inspections',
      path: '/admin/elevators/inspections',
      icon: <InspectionsMenuIcon />,
      disabled: false,
      show: true,
      main: true,
    },
    {
      id: 'elevatorsCertificates',
      name: 'Certificates',
      url: '/admin/elevators/certificates',
      path: '/admin/elevators/certificates',
      icon: <CertificatesMenuIcon />,
      disabled: false,
      show: true,
      main: true,
    },
    {
      id: 'guide',
      name: `User Guide`,
      url: assetUrl(
        '../../../DOB_Construction_Inspections_User_Guide_for_Admins_and_Inspectors.pdf'
      ),
      path: '/guide',
      icon: <FileTypePdfIcon />,
      disabled: false,
      show: true,
      isExternal: true,
    },
  ];
